// extracted by mini-css-extract-plugin
module.exports = {"formInput":"formInput_formInput__1VZxu"};